/**
 * Devuelve la misma imagen servida a través de un optimizador (wsrv.nl):
 * se convierte a WebP y se redimensiona al ancho realmente necesario,
 * lo que reduce el peso de la descarga sin cambiar el contenido visual.
 */
export function optimizedImage(src: string, width: number, quality = 80): string {
  return `https://wsrv.nl/?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}`
}

/**
 * Si el optimizador falla, se vuelve a la imagen original del CDN.
 */
export function fallbackToOriginal(
  event: React.SyntheticEvent<HTMLImageElement>,
  original: string,
): void {
  const img = event.currentTarget
  if (img.src !== original) {
    img.src = original
  }
}
